export default {
	host: 'http://api.okul724.net/',
	//host: 'http://localhost:5000/',
	imageUploaded: 'http://online.okul724.net/static/Uploads/',
}
